import { ReduxAction, DispatchFunc } from '../../core/types/redux';

export enum SidePanelActionConstants {
  MENU_EXTEND = '@@sidePanel/MENU_EXTEND',
  MENU_COLLAPSE = '@@sidePanel/MENU_COLLAPSE',
}

export type SidePanelAction<TArgs> = ReduxAction<TArgs, SidePanelActionConstants>;
export type SidePanelDispatchFunc<TArgs> = DispatchFunc<TArgs, SidePanelActionConstants>;

export interface SidePanelState {
  menuStatus: 'collapse' | 'extend';
}
